<template>
  <div class="zzzd_ERContainer" v-if="isShow">
    <div class="zzzd_Title">
      <i class="el-icon-back zzzd_icon" @click="goBack"></i>
      <span>诊断报告</span>
    </div>
    <el-alert  :title="successInfo" type="success" :closable="false" show-icon v-if="whetherCompany" class="zzzd-note"></el-alert>
    <el-alert  :title="failInfo" type="warning" :closable="false" show-icon v-else  class="zzzd-note" ></el-alert>
    <div class="zzzd_ERWrapper">
      <!-- 评估结果 -->
      <div class="zzzd_result" v-if="isPass">
        <div class="zzzd_Inner">
          <div class="zzzd_icon">
            <img src="@/assets/imgs/zzzd/成功.png" alt />
          </div>
          <div class="zzzd_desc">
            <span class="zzzd_desc_title">恭喜您！</span>
            <span class="zzzd_desc_result">初步评估您满足入驻资格</span>
          </div>
        </div>
      </div>
      <div class="zzzd_result" v-else>
        <div class="zzzd_Inner">
          <div class="zzzd_icon">
            <img src="@/assets/imgs/zzzd/失败.png" alt />
          </div>
          <div class="zzzd_desc">
            <span class="zzzd_desc_title">很遗憾！</span>
            <span class="zzzd_desc_result">初步评估您暂不满足入驻资格</span>
          </div>
        </div>
      </div>
      <!-- 推荐产品 -->
      <!-- <div class="zzzd_recommend">
        <div v-if="hasRecommend" style="display:flex">
          <div class="zzzd_decorate_line" style="margin-right: 20px;"></div>
          <div class="zzzd_decorate_square"></div>
          <div class="zzzd_header" v-if="isPass">已入驻企业还拥有以下资质</div>
          <div class="zzzd_header" v-else>入驻您还需要办理以下资质</div>
          <div class="zzzd_decorate_square" style="margin-right:20px"></div>
          <div class="zzzd_decorate_line"></div>
        </div>
      </div>-->
      <!-- <div class="zzzd_itemWrapper">
        <div class="zzzd_item" v-for="(item,index) in recommendList" :key="index">
          <div class="zzzd_item_title">{{item.name}}</div>
          <div class="zzzd_item_desc">{{item.describe}}</div>
          <div class="zzzd_item_price">面议
          </div>
          <div class="zzzd_item_btn" @click="freeChat(item)">免费咨询</div>
        </div>
      </div>-->
      <!-- 诊断信息 -->
      <div class="zzzd_Info">
        <div class="zzzd_title">诊断概览</div>
        <div class="itemWrap">
          <div class="item">
            <span class="item_label">公司名称</span>
            <span class="item_desc">{{corporate_name}}</span>
          </div>
          <div class="item">
            <span class="item_label">诊断类型</span>
            <span class="item_desc">{{diagnosis_type_name}}诊断</span>
          </div>
          <div class="item">
            <span class="item_label">联系电话</span>
            <span class="item_desc">{{publish_mobile}}</span>
          </div>
          <div class="item">
            <span class="item_label">主体资质</span>
            <span class="item_desc">企业</span>
          </div>
          <div class="item">
            <span class="item_label">主营类目</span>
            <span class="item_desc">{{main_class}}</span>
          </div>
          <div class="item">
            <span class="item_label">店铺类型</span>
            <span class="item_desc">旗舰店</span>
          </div>
          <div class="item">
            <span class="item_label">诊断时间</span>
            <span class="item_desc">2020-03-27 15：06：58</span>
          </div>
        </div>
        <!-- 已经拥有的资质 -->
        <div class="zzzd_qualification" v-if="own">
          <div class="zzzd_info_line"></div>
          <div class="zzzd_qualificationTitle">您已拥有以下资质</div>
          <div class="zzzd_bottom">
            <div v-if="baseData">
              <div class="zzzd_title">基础资质</div>
              <el-table :data="baseData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#3AC255">通过</span>
                </el-table-column>
              </el-table>
              <div class="line"></div>
            </div>
            <div v-if="brandData">
              <div class="zzzd_title">品牌资质</div>
              <el-table :data="brandData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#3AC255">通过</span>
                </el-table-column>
              </el-table>
              <div class="line"></div>
            </div>
            <div v-if="industryData">
              <div class="zzzd_title">行业资质</div>
              <el-table :data="industryData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#3AC255">通过</span>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 还需要办理的资质  -->
        <div class="zzzd_qualification" v-if="need">
          <div class="zzzd_info_line"></div>
          <div class="zzzd_qualificationTitle">以下为您还需办理资质</div>
          <div class="zzzd_bottom">
            <div v-if="NobaseData">
              <div class="zzzd_title">基础资质</div>
              <el-table :data="NobaseData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#F84251">未通过</span>
                </el-table-column>
              </el-table>
              <div class="line"></div>
            </div>
            <div v-if="NobrandData">
              <div class="zzzd_title">品牌资质</div>
              <el-table :data="NobrandData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#F84251">未通过</span>
                </el-table-column>
              </el-table>
              <div class="line"></div>
            </div>
            <div v-if="NoindustryData">
              <div class="zzzd_title">行业资质</div>
              <el-table :data="NoindustryData" border style="width: 50%">
                <el-table-column prop="picName" label="资质要求"></el-table-column>
                <el-table-column prop="result" label="智能诊断结果">
                  <span style="color:#F84251">未通过</span>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div @click="freeChat" class="chatBtn">立即咨询</div>
      </div>
      <!-- 留资弹出框框 -->
      <el-dialog title="免费咨询" :visible.sync="dialogFormVisible">
        <div class="zzzd_formLine"></div>
        <el-form :model="form" :rules="rules" ref="form">
          <div class="zzzd_formTitle">
            <span style="margin-right:20px">需求类型 :</span>
            {{diagnosis_type_name}}-{{main_class}}
          </div>
          <el-form-item label="公司名称 :" :label-width="formLabelWidth" prop="companyName">
            <el-input v-model="form.companyName" autocomplete="off" style="width:294px"></el-input>
          </el-form-item>
          <el-form-item label="姓名 :" :label-width="formLabelWidth" prop="name">
            <el-input v-model="form.name" autocomplete="off" style="width:294px"></el-input>
          </el-form-item>
          <el-form-item label="手机号 :" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="form.phone" autocomplete="off" style="width:294px" maxlength="11"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="danger" @click="submitForm('form')">提 交</el-button>
        </div>
        <div class="zzzd_formLine"></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import moment from "moment";
import {
  diagnosisDetail, //诊断详情
} from "@/api/qualification.js";
import {
  opSubmitNeed, //免费咨询
} from "@/api/zzzd_onNeed.js";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
export default {
  data() {
    let validateCompanyName = (rule, value, callback) => {
      let reg = /\S/g;
      if (!reg.test(value)) {
        callback(new Error("公司名称不能为空"));
      } else {
        callback();
      }
    };
    let validateName = (rule, value, callback) => {
      let reg = /\S/g;
      if (!reg.test(value)) {
        callback(new Error("名称不能为空"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      phone: "",
      isPass: null,
      isCanSubmit: false,
      isShow: false,
      recommendList: [],
      productId: "",
      productName: "",
      form: {
        name: "",
        companyName: "",
        phone: "",
      },
      formLabelWidth: "200px",
      rules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            validator: validateCompanyName,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateName, message: "请输入姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: validatePhone,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
      },
      diagnosis_no: "",
      channel_item_code: "",
      hasRecommend: true,
      baseData: null,
      brandData: null,
      industryData: null,
      NobaseData: null,
      NobrandData: null,
      NoindustryData: null,
      corporate_name: "", //公司名称
      corporate_type_name: "", //店铺类型
      diagnosis_type_name: "", //诊断类型
      publish_mobile: "", //联系电话
      main_class: "", //主营类目
      created_at: "", //诊断时间
      whetherCompany:null,//公司名称是否命中工商数据
      own:false,
      need:false,
    };
  },
  computed:{
    successInfo(){
      return `您好 “${this.corporate_name}”，根据诊断宝智能机器人通过大数据智能引擎分析结果如下：`
    },
    failInfo(){
      return `您好 “${this.corporate_name}”，根据诊断宝智能机器人通过大数据智能引擎分析"${this.corporate_name}"不是一个有效主体名称，分析结果如下：`
    },
  },
  methods: {
    freeChat() {
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          switch (this.productName) {
            case "公司注册":
              this.channel_item_code = "gszc";
              break;
            case "刻章服务":
              this.channel_item_code = "kzfu";
              break;
            case "工商变更":
              this.channel_item_code = "gsbg";
              break;
            case "工商年报":
              this.channel_item_code = "gsnb";
              break;
            case "税务报道":
              this.channel_item_code = "swbd";
              break;
            case "银行开户":
              this.channel_item_code = "yhkh";
              break;
            case "税控申请":
              this.channel_item_code = "sksq";
              break;
            case "ICP经营许可证":
              this.channel_item_code = "icpsq";
              break;
            case "EDI经营许可证":
              this.channel_item_code = "edisq";
              break;
            // case "食品经营许可证":
            case "软件著作权":
              this.channel_item_code = "rjzzq";
              break;
            case "美术作品著作权":
              this.channel_item_code = "mszzq";
              break;
            case "文字版权登记":
              this.channel_item_code = "wzbqdj";
              break;
            case "商标注册":
              this.channel_item_code = "fzsbzc";
              break;
            case "云上园区注册":
              this.channel_item_code = "ysgszc";
              break;
            case "注册地址":
              this.channel_item_code = "zcdz";
              break;
            case "社保开户":
              this.channel_item_code = "sbkh";
              break;
            case "代理记账":
              this.channel_item_code = "gsdz";
              break;
            default:
              break;
          }
          let params = {
            area: "",
            description: this.productName,
            type: this.channel_item_code,
            mobile: this.form.phone,
            userName: this.form.companyName,
          };
          // 提交需求
          opSubmitNeed(params).then((res) => {
            if (res.status === 0) {
              this.$router.push({ path: "/diagnose/personal/demandInfo" });
            }else if(res.status == -99){
              this.$message('登录超时，请重新登录')
              this.logout()
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goBack() {
      this.$router.push("/diagnose/personal/myDiagnosis");
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
  },
  mounted() {
    // 诊断详情
    let loadingInstance = Loading.service();
    diagnosisDetail({ diagnosisNo: this.$route.query.diagnosis_no }).then(
      (res) => {
        if (res.status == 0) {
          loadingInstance.close();
          this.isShow = true;
          this.corporate_name = res.data.corporate_name;
          this.corporate_type_name = res.data.corporate_name;
          this.diagnosis_type_name = res.data.diagnosis_type_name;
          this.publish_mobile = res.data.publish_mobile;
          if(res.data.whether_company == 1){
            this.whetherCompany = true
          }else if(res.data.whether_company == 0){
            this.whetherCompany = false
          }
          if(res.data.main_class){
            let mainClass = JSON.parse(res.data.main_class).join("、");
            // console.log(mainClass);
            this.main_class = mainClass;
          }
          this.created_at = moment(res.data.created_at).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            res.data.qualifications_pic &&
            res.data.qualifications_pic.length != 0
          ) {
            this.baseData = res.data.qualifications_pic;
            this.own = true
          }
          if (res.data.brand_pic && res.data.brand_pic.length != 0) {
            this.brandData = res.data.brand_pic;
            this.own = true
          }
          if (res.data.industry_pic && res.data.industry_pic.length != 0) {
            this.industryData = res.data.industry_pic;
            this.own = true
          }
          if (
            res.data.needQualifications_pic &&
            res.data.needQualifications_pic.length != 0
          ) {
            this.NobaseData = res.data.needQualifications_pic;
            this.need = true
          }
          if (res.data.needBrand_pic && res.data.needBrand_pic.length != 0) {
            this.NobrandData = res.data.needBrand_pic;
            this.need = true
          }
          if (
            res.data.needIndustry_pic &&
            res.data.needIndustry_pic.length != 0
          ) {
            this.NoindustryData = res.data.needIndustry_pic;
            this.need = true
          }
          if (res.data.diagnosis_result_data) {
            this.recommendList = res.data.diagnosis_result_data.data.recommend;
            this.isPass = res.data.diagnosis_result_data.data.isPass;
          } else {
            if (res.data.diagnosis_result_name == "通过") {
              this.isPass = true;
            } else {
              this.isPass = false;
            }
            this.hasRecommend = false;
          }
        }else if(res.status == -99){
          this.$message('登录超时，请重新登录')
          this.logout()
        }
      }
    );
    this.diagnosis_no = this.$route.query.diagnosis_no;
    
  },
};
</script>

<style lang="scss" scoped>
.zzzd_ERContainer {
  background: #ebecef;
  width: 100%;
  min-height: 100%;
  border-top: 1px solid #ebecef;
  padding-bottom: 29px;
  .zzzd-note{
    height: 40px;
    span{
      font-size: 16px !important;
    }
  }
  .zzzd_Title {
    width: 100%;
    height: 50px;
    background: #fff;
    font-size: 18px;
    padding-left: 20px;
    line-height: 50px;
    font-weight: 600;
    .zzzd_icon {
      color: #409eff;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .zzzd_ERWrapper {
    padding: 20px;
    .zzzd_steps {
      display: flex;
      .zzzd_circle {
        width: 32px;
        height: 32px;
        color: #d8374d;
        font-size: 16px;
        font-family: HelveticaNeue;
        line-height: 32px;
        text-align: center;
        border-radius: 55%;
        border: 1px solid #d8374d;
        &.active {
          background: rgba(216, 55, 77, 1);
          border: 1px solid rgba(216, 55, 77, 1);
          color: #fff;
        }
      }
      .zzzd_step {
        width: 64px;
        height: 24px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666;
        line-height: 24px;
        margin: 4px 8px;
        &.active {
          font-weight: 500;
          color: #000;
        }
      }
      .zzzd_line {
        width: 192px;
        height: 1px;
        background: #ddd;
        margin-top: 17px;
        margin-right: 15px;
        margin-left: 22px;
      }
    }
    .zzzd_result {
      width: 100%;
      height: 200px;
      background: #fff;
      position: relative;
      .zzzd_Inner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: inline-flex;
        .zzzd_icon {
          width: 75px;
          height: 73px;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .zzzd_desc {
          display: flex;
          flex-direction: column;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          .zzzd_desc_title {
            font-size: 30px;
            color: rgba(0, 0, 0, 1);
            line-height: 42px;
            margin-bottom: 6px;
          }
          .zzzd_desc_result {
            font-size: 14px;
            color: rgba(74, 74, 74, 1);
            line-height: 20px;
            letter-spacing: 1px;
          }
        }
      }
    }
    .zzzd_Info {
      padding: 0 20px 30px;
      background: #fff;
      margin-top: 20px;
      .zzzd_title {
        font-size: 16px;
        font-weight: 600;
        line-height: 50px;
      }
      .itemWrap {
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 50%;
          margin-bottom: 20px;
          .item_label {
            color: #999;
            display: inline-block;
            width: 100px;
          }
          .item_desc {
            color: #333;
          }
        }
      }
      .zzzd_info_line {
        width: 100%;
        height: 1px;
        background: #ccc;
      }
      .zzzd_qualification {
        .zzzd_qualificationTitle {
          font-size: 24px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 31px;
          margin-top: 30px;
          margin-bottom: 30px;
        }
        .zzzd_bottom {
          padding: 0 20px 20px;
          background: #fff;
          .zzzd_title {
            font-size: 16px;
            font-weight: 600;
            line-height: 50px;
          }
          .el-table {
            margin-bottom: 30px;
          }
          .line {
            width: 100%;
            height: 1px;
            background: #eee;
          }
        }
      }
      .chatBtn {
        width: 160px;
        height: 54px;
        background: #d8374d;
        border-radius: 4px;
        margin: auto;
        line-height: 54px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
    .zzzd_recommend {
      display: flex;
      padding: 0 133px;
      margin-bottom: 30px;
      .zzzd_header {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 37px;
        text-align: center;
        margin: 0 10px;
      }
      .zzzd_decorate_line {
        width: 217px;
        height: 1px;
        background: #dfdfdf;
        margin-top: 20px;
      }
      .zzzd_decorate_square {
        width: 12px;
        height: 12px;
        background: rgba(216, 216, 216, 1);
        transform: rotate(45deg);
        margin-top: 15px;
      }
    }
    .zzzd_itemWrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      // padding-left: 60px;;
      div:nth-child(3n) {
        margin-right: 0;
      }
      .zzzd_item {
        width: 369px;
        height: 169px;
        padding-top: 35px;
        padding-left: 61px;
        background-image: url(../../../../assets/imgs/zzzd/优惠券.png);
        margin-bottom: 40px;
        margin-right: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        position: relative;
        .zzzd_item_title {
          font-size: 22px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.65);
          line-height: 30px;
          margin-bottom: 6px;
          width: 190px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .zzzd_item_desc {
          font-size: 18px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          line-height: 20px;
          width: 180px;
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .zzzd_item_price {
          position: absolute;
          right: 14px;
          top: 51px;
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(239, 17, 21, 1);
          line-height: 67px;
          // width: 90px;
          // word-break: all;
          span {
            font-size: 12px;
            font-weight: 600;
          }
        }
        .zzzd_item_btn {
          cursor: pointer;
          width: 110px;
          height: 29px;
          background: rgba(254, 84, 68, 1);
          border-radius: 20px;
          margin-top: 18px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 29px;
          text-align: center;
        }
      }
    }
    .el-dialog {
      .el-dialog__body {
        padding: 0;
      }
      .zzzd_formTitle {
        margin-left: 127px;
        margin-bottom: 27px;
        margin-top: 40px;
        font-size: 14px;
      }
      .zzzd_formLine {
        width: 100%;
        height: 1px;
        border-radius: 6px 6px 0px 0px;
        background: rgba(220, 220, 220, 1);
      }
    }
  }
}
</style>